var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1430105508"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40414",
    width: 31,
    height: 31,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4794 19.3392L22.9625 23.8223C23.2 24.0592 23.5847 24.0592 23.8223 23.8223C24.0592 23.5847 24.0592 23.2 23.8223 22.9625L19.3392 18.4794C20.36 17.2647 20.9755 15.6976 20.9755 13.9878C20.9755 10.1311 17.8444 7 13.9878 7C10.1311 7 7 10.1311 7 13.9878C7 17.8444 10.1311 20.9755 13.9878 20.9755C15.6976 20.9755 17.2647 20.36 18.4794 19.3392ZM13.9878 8.21526C17.1736 8.21526 19.7603 10.8019 19.7603 13.9878C19.7603 17.1736 17.1736 19.7603 13.9878 19.7603C10.8019 19.7603 8.21526 17.1736 8.21526 13.9878C8.21526 10.8019 10.8019 8.21526 13.9878 8.21526ZM11.2534 14.5954H16.7221H16.7258C17.0593 14.5936 17.3297 14.322 17.3297 13.9878C17.3297 13.6523 17.0575 13.3801 16.7221 13.3801H11.2534C10.918 13.3801 10.6458 13.6523 10.6458 13.9878C10.6458 14.3232 10.918 14.5954 11.2534 14.5954Z",
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.0eff9a4cfa4be8464bd364ba6d461ecc.svg";
export { ForwardRef as ReactComponent };